import { z } from "zod"

import { payrollProfileStateV1Schema } from "./employee-payroll-profile-v1.js"

const maskedSummarySchema = z.union([
  z.literal("not_provided"),
  z.string().regex(/^ending_[A-Za-z0-9]{2,4}$/),
])

export const contractorPayrollProfileSyncV1Schema = z
  .object({
    requestVersion: z.literal(1),
    correlationId: z.string().uuid(),
    idempotencyKey: z.string().min(8).max(128),
    expectedVersion: z.number().int().nonnegative(),
    profileId: z.string().uuid(),
    workerId: z.string().uuid(),
    contractorEngagementId: z.string().uuid(),
    legalEntityId: z.string().uuid(),
    providerContractorId: z.string().regex(
      /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/,
    ),
    state: payrollProfileStateV1Schema,
    maskedTaxSummary: maskedSummarySchema,
    maskedPaymentSummary: maskedSummarySchema,
  })
  .strict()

export const contractorPayrollProfileResultV1Schema = z
  .object({
    entityType: z.literal("contractor_payroll_profile"),
    entityId: z.string().uuid(),
    state: payrollProfileStateV1Schema,
    version: z.number().int().positive(),
    workerId: z.string().uuid(),
    contractorEngagementId: z.string().uuid(),
    legalEntityId: z.string().uuid(),
    providerContractorRef: z.string().regex(/^[a-f0-9]{16}$/),
    maskedTaxSummary: maskedSummarySchema,
    maskedPaymentSummary: maskedSummarySchema,
    relationshipEffective: z.literal(true),
    sensitiveDataStored: z.literal(false),
  })
  .strict()

export type ContractorPayrollProfileSyncV1 = z.infer<
  typeof contractorPayrollProfileSyncV1Schema
>
export type ContractorPayrollProfileResultV1 = z.infer<
  typeof contractorPayrollProfileResultV1Schema
>
